import script from "./WhySection.vue?vue&type=script&setup=true&lang=js"
export * from "./WhySection.vue?vue&type=script&setup=true&lang=js"

import "./WhySection.vue?vue&type=style&index=0&id=20075fe1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20075fe1"]])

export default __exports__